<template>
  <div id="privacy-policy-content" class="support-content" v-html="supportContent"></div>
</template>


<script>
import supportMixins from "../../mixins/supportMixins";

export default {
  metaInfo: {
    title: "Privacy Policy | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "We collect information from you when you register on our site, place an order or subscribe to our newsletter"
      },
      {
        vmid: "keywords",
        name: "keywords",
        content: "1byone, 1byone health, privacy policy, user policy"
      }
    ]
  },
  mixins: [supportMixins("PrivacyPolicy")]
};
</script>